/* ============================================================
   MP — Vignettes de couleurs reliees
   • Cartes (context "card") : les fleches font DEFILER les coloris
     un par un (change la photo + le compteur "2 / 4 couleurs").
     Sur mobile la bande de vignettes est masquee (CSS) : il ne
     reste que le compteur et les fleches, facon Oliver Peoples.
   • Page produit (context "pdp") : les fleches defilent la bande.
   Markup : snippets/mp-color-swatches.liquid  •  Styles : theme.css
   ============================================================ */
(function () {
  if (window.customElements && customElements.get('mp-color-swatches')) return;

  class MpColorSwatches extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mp-cs__track');
      this.prevBtn = this.querySelector('[data-cs-prev]');
      this.nextBtn = this.querySelector('[data-cs-next]');
      if (!this.track) return;

      this.context = this.dataset.context || 'card';
      this.thumbs = Array.from(this.querySelectorAll('.mp-cs__thumb'));
      this.countEl = this.querySelector('.mp-cs__count');
      this.total = this.thumbs.length;
      this._onScroll = this._onScroll.bind(this);

      // Index courant = vignette active (le produit affiche), sinon 0.
      this.current = Math.max(0, this.thumbs.findIndex((t) => t.classList.contains('is-active')));

      // Contexte carte : apercu du coloris (change la photo de la carte).
      this.card = null;
      if (this.context !== 'pdp') {
        this.card = this.closest('product-card') || this.closest('.product-card');
        if (this.card) {
          this.thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', (e) => {
              if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
              e.preventDefault();
              this.current = index;
              this._preview(thumb, index);
              this._syncArrows();
            });
          });
        }
      }

      // Mode DEFILEMENT des coloris sur les cartes (fleches = coloris suivant/precedent).
      this.cycle = this.context !== 'pdp' && this.card && this.total > 1;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.cycle) { this._go(-1); }
          else { this.track.scrollBy({ left: -this._step(), behavior: 'smooth' }); }
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.cycle) { this._go(1); }
          else { this.track.scrollBy({ left: this._step(), behavior: 'smooth' }); }
        });
      }

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      requestAnimationFrame(() => this._sync());
      window.addEventListener('resize', this._onScroll, { passive: true });
    }

    // Coloris suivant/precedent (borne, sans boucle) puis apercu.
    _go(dir) {
      const next = this.current + dir;
      if (next < 0 || next > this.total - 1) return;
      this.current = next;
      const thumb = this.thumbs[next];
      if (thumb) this._preview(thumb, next);
      // Garde la vignette active visible dans la bande (desktop).
      if (thumb && thumb.scrollIntoView) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      this._syncArrows();
    }

    _preview(thumb, index) {
      if (!this.card) return;
      const src = thumb.getAttribute('data-mp-img');
      const url = thumb.getAttribute('href');

      const primary = this.card.querySelector('.product-card__image--primary');
      if (primary && src) {
        // On retire les hints de taille figes (srcset/sizes/width/height) pour
        // que la nouvelle image occupe tout le conteneur comme l'originale
        // (sinon elle s'affiche petite au changement de coloris).
        primary.removeAttribute('srcset');
        primary.removeAttribute('sizes');
        primary.removeAttribute('width');
        primary.removeAttribute('height');
        primary.setAttribute('src', src);
      }

      this.card.classList.add('mp-cs-previewing');

      if (url) {
        const mediaLink = this.card.querySelector('.product-card__media');
        if (mediaLink) mediaLink.setAttribute('href', url);
        this.card
          .querySelectorAll('.prado-product-card__title, .product-title')
          .forEach((a) => a.setAttribute('href', url));
      }

      this.thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (this.countEl) this.countEl.textContent = (index + 1) + ' / ' + this.total + ' couleurs';
    }

    _step() {
      return Math.max(this.track.clientWidth * 0.8, 96);
    }

    _onScroll() {
      if (!this.cycle) this._sync();
    }

    // Mode defilement : etat des fleches selon l'index courant.
    _syncArrows() {
      if (!this.cycle) return;
      if (this.prevBtn) this.prevBtn.disabled = this.current <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.current >= this.total - 1;
    }

    _sync() {
      if (this.cycle) { this._syncArrows(); return; }
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      this.classList.toggle('mp-cs--scroll', overflow > 1);
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= overflow - 1;
    }
  }

  customElements.define('mp-color-swatches', MpColorSwatches);
})();
